@if (feature?.value) {
  @if (feature.translation) {
    <div class="text-value body-s semibold">
      {{ feature.translation | translate }}
    </div>
  } @else {
    <mat-icon class="has-value">check</mat-icon>
  }
} @else {
  <div class="no-value">—</div>
}
